<template>
  <section class="user-profile-header">
    <AlertBox
      type="danger"
      v-if="hasError"
    >{{ error }}</AlertBox>

    <AvatarBox
      v-if="user.avatar"
      :avatar="user.avatar"
      :title="user.name"
      size="lg"
      class="mb-2"
    >
      <UploadOverlayButton
        @success="error = null"
        @error="err => error = err"
      />
    </AvatarBox>

    <h4 class="name">{{ user.name }}</h4>
    <h3 class="email">{{ user.email }}</h3>

    <slot />
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AvatarBox from '@/components/user/AvatarBox'
  import UploadOverlayButton from '@/components/buttons/UploadOverlayButton'
  import AlertBox from '@/components/layout/AlertBox'

  export default {
    components: {
      AvatarBox,
      UploadOverlayButton,
      AlertBox
    },

    data: () => ({
      error: null
    }),

    computed: {
      ...mapGetters('user', ['user']),

      hasError () {
        return !!this.error
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .user-profile-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0 20px;
    background: $purple20;

    picture {
      margin-bottom: 15px;
    }

    .name {

    }

    .email {
      font-size: 0.89rem;
      margin: 8px 0;
    }
  }
</style>